$(document).ready(function () {
  let currentTabId = 0;

  $(".offers-cards-nav .nav-item").on("click", function () {
    $(".offers-cards-nav .nav-item .nav-link.active").removeClass("active");
    $(".tab-content .tab-pane.active").removeClass("active");

    currentTabId = +$(this).attr("data-tab-id");

    $($(".offers-cards-nav .nav-item")[currentTabId])
      .find(".nav-link")
      .addClass("active");
    $($(".tab-content .tab-pane")[currentTabId]).addClass("active");
  });
});
